(function () {
  function boot() {
    document.querySelectorAll('[id^="WhatsAppFloating-"]').forEach((el) => {
      if (el.dataset.dragReady === 'true') return;
      if (el.dataset.draggable !== 'true') return;
      el.dataset.dragReady = 'true';

      if (typeof window.initFloatingDrag !== 'function') return;

      window.initFloatingDrag(el, {
        storageKey: `floating-whatsapp-position:${el.id}`,
        dragHandle: el,
        onTap: () => {
          const href = el.getAttribute('href');
          if (!href) return;
          if (el.target === '_blank') {
            window.open(href, '_blank', 'noopener,noreferrer');
          } else {
            window.location.href = href;
          }
        },
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
